export const setInputProps = inputProps => ({
  type: 'FILE_INPUT/REPLACE_PROPS',
  inputProps,
});

export const clickFileInput = inputProps => async dispatch => {
  await dispatch(setInputProps(inputProps));
  document.getElementById('FileInputRoot').click();
};

export const setFile = file => ({
  type: 'FILE_INPUT/SET_FILE',
  file,
});

export const updateFile = update => ({
  type: 'FILE_INPUT/UPDATE_FILE',
  update,
});

export const setUploading = isUploading => ({
  type: 'FILE_INPUT/SET_UPLOADING',
  isUploading,
});

export const setError = error => ({
  type: 'FILE_INPUT/SET_ERROR',
  error,
});

export const resetFile = () => ({
  type: 'FILE_INPUT/RESET_FILE',
});

export const resetInput = () => ({
  type: 'FILE_INPUT/RESET_INPUT',
});
